import { merge } from 'ramda';
import { SUCCESS, REQUEST, FAIL } from 'src/store/actions/worksInOtherDepartmentsActions';

const initialState = {
  data: {},
  fetching: false,
  errors: []
};

const worksInOtherDepartments = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { data: action.worksInOtherDepartments, fetching: false, errors: [] });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default worksInOtherDepartments;
